
/* injects from baggage-loader */

'use strict';

import AccountCodesController from './account.codes.controller';
import AccountCodesTemplate from './account.codes.html';

export default class AccountCodesComponent {
		constructor() {
				this.templateUrl = AccountCodesTemplate;
				this.controller = AccountCodesController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				// this.bindings = { };
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/account/codes/account.codes.component.js